export const isObject = (v: unknown): v is Record<string, unknown> => !!v && typeof v === "object";

export const isKeyOf = <Obj extends object>(
    key: string | number | symbol,
    obj: Obj,
): key is keyof Obj => key in obj;
